import React from 'react';
import styled from 'styled-components';
import StatusBox from '@commoncomponents/frontend-components/dist/components/StatusBox';
import { breakpoints } from '@commoncomponents/frontend-components/dist/styled';
const Warning = ({ message }) => (React.createElement(StatusWrapper, { className: "status-wrapper" },
    React.createElement(StatusBox, { variant: "WARNING", classes: { WARNING: 'status-box' } }, message)));
const StatusWrapper = styled.div `
  padding: 16px 24px 0;
  width: 100%;
  .status-box {
    border-radius: 8px;
    justify-content: flex-start;
    height: auto;
    min-height: 56px;
    padding: 16px;

    div:first-child {
      margin-right: 6px;
    }
  }
  @media ${breakpoints.md} {
    padding: 0 0 12px;
  }
`;
export default Warning;
